<ion-content scroll-y="false">
    <rwidget-alert></rwidget-alert>

    <div class="inset-0 flex items-center justify-center">
        <div class="flex h-full max-h-full w-full flex-col rounded-2xl text-base">
            <!-- Header Section -->
            <div class="fixed-transform-fix bg-white p-4">
                <div class="relative flex w-full items-center justify-center py-2 pb-4">
                    <p class="text-center font-semibold">{{ 'TRAVEL_VIA' | translate }}</p>
                    <div class="absolute right-0">
                        <button
                            [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                            (click)="closeModal()"
                            mat-icon-button>
                            <mat-icon class="text-grey-zambezy">close</mat-icon>
                        </button>
                    </div>
                </div>

                <div>
                    <ion-searchbar
                        class="rounded-lg border-0 p-0 text-contrast-black dark:bg-contrast-yellow"
                        id="route-modal-search"
                        [placeholder]="'SEARCH' | translate"
                        [searchIcon]="(assetsPath$ | async) + '/img/explore/search_icon.svg'"
                        (ionInput)="filterRoutes($event)"
                        show-clear-button="never"
                        mode="ios">
                    </ion-searchbar>
                </div>
            </div>

            <div class="mt-1 flex bg-white p-4">
                <p class="text-xs font-semibold tracking-wide">{{ 'ROUTES' | translate | uppercase }}</p>
                <ng-container *ngIf="getSelectedRoutes()">
                    <span class="text-xs" *ngFor="let route of getSelectedRoutes()">
                        &nbsp;
                        {{ route.shortName }}
                    </span>
                </ng-container>
            </div>

            <div class="flex-1 overflow-y-auto bg-white px-4 pb-4">
                <ul class="pb-4" *ngIf="filteredRoutes?.length">
                    <li
                        class="flex items-center border-b border-solid py-3.5 dark:border-contrast-yellow"
                        *ngFor="let route of filteredRoutes">
                        <label class="checkbox-wcag">
                            <input
                                class="checkbox-wcag__checkbox"
                                [name]="route.shortName"
                                [attr.checked]="route.selected ? '' : null"
                                [title]="route.shortName"
                                [attr.aria-label]="route.shortName"
                                (change)="onCheckboxChange(route, $event)"
                                type="checkbox" />
                            <span class="checkbox-wcag__checkmark"></span>
                        </label>

                        <div
                            class="ml-5 flex h-7 min-w-[1.75rem] items-center justify-center whitespace-nowrap rounded-full text-xs font-bold text-white dark:text-contrast-black"
                            [ngClass]="[route.shortName.length > 3 ? 'px-1' : '']"
                            [style.background-color]="routeColor(route)">
                            {{ route.shortName }}
                        </div>
                        <p class="ml-3.5 text-base font-bold leading-5">
                            {{ route.longName }}
                        </p>
                    </li>
                </ul>
            </div>

            <!-- Buttons Section -->
            <div class="fixed-transform-fix flex flex-col bg-white p-4 shadow-modal-footer">
                <ion-button
                    class="m-0 h-16 text-base font-semibold normal-case leading-5 text-secondary dark:text-contrast-yellow"
                    (click)="resetAll()"
                    fill="clear">
                    <ion-icon
                        class="gl-light-dark:h-4 gl-light-dark:w-4 mr-2 h-8 w-8 text-base dark:filter-yellow"
                        [title]="'RESET' | translate"
                        [src]="(assetsPath$ | async) + '/img/journey-planner/reset.svg'">
                    </ion-icon>
                    {{ 'RESET' | translate }}
                </ion-button>

                <ion-button
                    class="h-16 text-base font-semibold normal-case leading-5 !text-black dark:text-contrast-yellow"
                    (click)="chooseRoutes()"
                    color="secondary">
                    {{ 'CHOOSE' | translate }}
                </ion-button>
            </div>
        </div>
    </div>
</ion-content>
